module.exports = __webpack_public_path__ + "media/how-it-works.d75c5583.mp4";